
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/launch/week-3",
      function () {
        return require("private-next-pages/launch/week-3.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/launch/week-3"])
      });
    }
  